module.exports = __webpack_public_path__ + "img/c8ff54f1c071c73d2de5c6eae31bd410.png";